module.exports = __webpack_public_path__ + "static/media/example_2.c359289f.png";